import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AssetTag } from '@kentik/ui-shared/dictionary/types';
import { assetTagsQuery } from 'app/stores/dictionary/raw/assetTags';

export const useAssetTags = (): UseQueryResult<AssetTag[], Error> => useQuery(assetTagsQuery);
